import {
  type Dictionary,
  detectScript,
  type Script,
  type ScriptConversion,
  type ScriptTables,
  type ScriptTarget,
  toScriptPieces,
} from "@kensio/pinyinjs";

/**
 * Running a script conversion, with the source script worked out for you.
 *
 * The package takes a target and treats the source script as a hint. The
 * target is not in question here — the page writes all three of them at once
 * and asks nothing — so all that is left is the hint, and the hint is worth
 * having: knowing a text is already 繁體 stops the converter reading a
 * character it shares with 简体 as something to change.
 *
 * Kept apart from the tool so it can be exercised without a page.
 */

/**
 * The script a text is written in, where its characters settle the question.
 *
 * Undefined for text that says nothing either way, which is common: most
 * characters were untouched by simplification, so a sentence containing none
 * of the changed ones is neither 简体 nor 繁體. That is not a problem to
 * solve. A conversion with no hint still runs, and text the two scripts share
 * comes out of it unchanged.
 */
export function sourceScript(
  text: string,
  tables: ScriptTables,
): Script | undefined {
  return detectScript(text, tables.hansOnly, tables.hantOnly);
}

/**
 * Convert a text into one orthography.
 */
export function convertScript(
  dictionary: Dictionary,
  tables: ScriptTables,
  text: string,
  to: ScriptTarget,
  from: Script | undefined,
): ScriptConversion {
  return toScriptPieces(dictionary, tables, text, {
    to,
    ...(from !== undefined && { from }),
  });
}
